import { useMemo } from "react";
import useAmpolServiceDataStore from "@/use-ampol-service-data-store";
import useSelectionStore from "@/use-selection-store";
import { AmpolService } from "./types";

const useSelection = () => {
  const selection = useSelectionStore((store) => store.selection);

  const ampolServices = useAmpolServiceDataStore((store) => store.services);

  const ampolService = useMemo(() => {
    if (selection == null) {
      return undefined;
    }

    return (ampolServices ?? new Map<string, AmpolService>()).get(selection);
  }, [ampolServices, selection]);

  return { ampolService, selection };
};

export default useSelection;
